































































import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { State } from 'vuex-class'

import AppTextField from '@/components/AppTextField.vue'
import AppTabs from '@/components/AppTabs.vue'
import AppDialog from '@/components/AppDialog.vue'
import ListItemRules from '@/modules/ReportsRules/components/ListItemRules.vue'
import { CheckboxModel } from '../interfaces/checkbox-model'
import DialogSelectDayForm from '@/modules/ReportsRules/components/DialogSelectDayForm.vue'
import DialogMultiSelectorForm from '@/modules/ReportsRules/components/DialogMultiSelectorForm.vue'
import SearchCarrier from '@/mixins/search-queries/search-carrier'
import SearchCarrierProduct from '@/mixins/search-queries/search-carrier-product'
import SearchProducer from '@/mixins/search-queries/search-producer'
import SearchGeneralAgent from '@/mixins/search-queries/search-ga'
import SearchBook from '@/mixins/search-queries/search-book'
import SearchRecordType from '@/mixins/search-queries/search-record-type'
import { policyTypeValues, policyType, policyTypeKeys } from '@/modules/Policy/helpers/policy'
import AppSelector from '@/components/AppSelector.vue'

import { FilterModel, FilterSelect, FilterSelectOption } from '../interfaces/filter-model'
import { User } from '../../User/interfaces/user'
import { deletePolicyReportRuleById, editPolicyReportRule, newPolicyReportRule } from '../gql/report-rule.gql'
import { showErrors, showNotification } from '../../../utils/snack'
import { RecordTypeMaster } from '@/modules/RecordType/interfaces/record-type'
import { PolicyReportRule, RelationCondition, RuleOrderBy } from '../interfaces/report-rule'
import { SnackType } from '../../../interfaces/snack'

@Component({
  components: {
    AppDialog,
    ListItemRules,
    DialogSelectDayForm,
    AppTextField,
    AppTabs,
    DialogMultiSelectorForm,
    AppSelector
  }
})

export default class SceneDialog extends mixins(SearchRecordType, SearchCarrier, SearchCarrierProduct, mixins(SearchProducer, SearchGeneralAgent, SearchBook)) {
  @Prop({ type: Boolean }) readonly show!: boolean
  @Prop({ type: Object as () => CheckboxModel }) readonly items!: CheckboxModel
  @Prop({ type: Array as () => PolicyReportRule[] }) readonly rules!: PolicyReportRule[]

  @State((state) => state.user.me) me!: User;

  tabActive = 0
  tabTitles = ['Filter Condition', 'Table Header']

  showDialog = false
  isDisplayForm = false
  isDelete = false
  targetRule: PolicyReportRule | null = null

  policyTypeOptions = policyTypeValues
  yesOrNo = ['Yes', 'No']
  paymentOptions = ['> 0', '= 0']

  savedData: string[] = []

  relationConditionMap = [
    RelationCondition.CONTAINS,
    RelationCondition.WITHOUT
  ]

  displayColumns: string[] = []
  orderBy: RuleOrderBy | null = null
  asc: Boolean | null = null

  filter: FilterModel = {
    bindDate: {
      label: 'Bind date',
      key: 'bindDate',
      value: null
    },
    effectiveDate: {
      label: 'Effective Date',
      key: 'effectiveDate',
      value: null
    },
    expirationDate: {
      label: 'Expiration Date',
      key: 'expirationDate',
      value: null
    },
    cancelDate: {
      label: 'Cancel Date',
      key: 'cancelDate',
      value: null
    },
    generalAgent: {
      label: 'General Agent',
      key: 'generalAgent',
      type: -1,
      value: [],
      options: []
    },
    carrier: {
      label: 'Carrier',
      key: 'carrier',
      type: -1,
      value: [],
      options: []
    },
    source: {
      label: 'Source',
      key: 'source',
      type: -1,
      value: [],
      options: []
    },
    insuranceProduct: {
      label: 'Insurance Product',
      key: 'insuranceProduct',
      type: -1,
      value: [],
      options: []
    },
    recordType: {
      label: 'Record Type',
      key: 'recordType',
      type: -1,
      value: [],
      options: []
    },
    policyType: {
      label: 'Policy Type',
      key: 'policyType',
      type: -1,
      value: [],
      options: this.policyTypeOptions
    },
    nonRenew: {
      label: 'Non Renew',
      value: -1,
      options: this.yesOrNo
    },
    payment: {
      label: 'Payment',
      value: -1,
      options: this.paymentOptions
    }
  }

  displayColumnsMap: CheckboxModel = {}

  sceneName = ''

  async created () {
    this.getCandidateRecordTypes(RecordTypeMaster.POLICY)
  }

  async newRulePost () {
    if (!this.me) {
      return
    }

    const { relationConditionMap, sceneName, displayColumns, orderBy, asc } = this

    const {
      bindDate, effectiveDate, expirationDate, cancelDate,
      generalAgent, carrier, source, insuranceProduct, recordType,
      policyType, nonRenew, payment
    } = this.filter

    const input: any = {}

    if (bindDate.value !== null) {
      input.bindDate = parseInt(bindDate.value)
    }

    if (effectiveDate.value !== null) {
      input.effectiveDate = parseInt(effectiveDate.value)
    }

    if (expirationDate.value !== null) {
      input.expirationDate = parseInt(expirationDate.value)
    }

    if (cancelDate.value !== null) {
      input.cancelDate = parseInt(cancelDate.value)
    }

    if (relationConditionMap[generalAgent.type] && generalAgent.value && generalAgent.value.length) {
      input.gaConditionValue = generalAgent.value.map(i => (generalAgent.options as FilterSelectOption[])[i].id)
      input.gaCondition = relationConditionMap[generalAgent.type]
    }

    if (relationConditionMap[carrier.type] && carrier.value && carrier.value.length) {
      input.carrierConditionValue = carrier.value.map(i => (carrier.options as FilterSelectOption[])[i].id)
      input.carrierCondition = relationConditionMap[carrier.type]
    }

    if (relationConditionMap[source.type] && source.value && source.value.length) {
      input.sourceConditionValue = source.value.map(i => (source.options as FilterSelectOption[])[i].id)
      input.sourceCondition = relationConditionMap[source.type]
    }

    if (relationConditionMap[insuranceProduct.type] && insuranceProduct.value && insuranceProduct.value.length) {
      input.insuranceProductConditionValue = insuranceProduct.value.map(i => (insuranceProduct.options as FilterSelectOption[])[i].id)
      input.insuranceProductCondition = relationConditionMap[insuranceProduct.type]
    }

    if (relationConditionMap[recordType.type] && recordType.value && recordType.value.length) {
      input.recordTypeConditionValue = recordType.value.map(i => (recordType.options as FilterSelectOption[])[i].id)
      input.recordTypeCondition = relationConditionMap[recordType.type]
    }

    if (relationConditionMap[policyType.type] && policyType.value && policyType.value.length) {
      input.policyTypeConditionValue = policyType.value.map(i => (policyTypeKeys as string[])[i])
      input.policyTypeCondition = relationConditionMap[policyType.type]
    }

    if (nonRenew.value !== -1) {
      input.nonRenew = nonRenew.value === 0
    }

    if (payment.value !== -1) {
      input.hasPayment = payment.value === 0
    }

    input.name = sceneName
    input.displayColumns = displayColumns
    input.asc = asc && orderBy ? asc : null
    input.orderBy = orderBy || null

    try {
      const result = await this.$apollo.mutate({
        mutation: newPolicyReportRule,
        variables: {
          input
        }
      })

      const res = result.data.newPolicyReportRule
      if (res) {
        showNotification({
          msg: 'Create new report rule successfully',
          type: SnackType.Success
        })
      }

      this.handleClose()
      this.handleRefresh()
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  async editRulePost () {
    if (!this.me || !this.targetRule) {
      return
    }

    const { relationConditionMap, sceneName, displayColumns, orderBy, asc } = this

    const {
      bindDate, effectiveDate, expirationDate, cancelDate,
      generalAgent, carrier, source, insuranceProduct, recordType,
      policyType, nonRenew, payment
    } = this.filter

    const input: any = {}

    if (bindDate.value !== null) {
      input.bindDate = parseInt(bindDate.value)
    }

    if (effectiveDate.value !== null) {
      input.effectiveDate = parseInt(effectiveDate.value)
    }

    if (expirationDate.value !== null) {
      input.expirationDate = parseInt(expirationDate.value)
    }

    if (cancelDate.value !== null) {
      input.cancelDate = parseInt(cancelDate.value)
    }

    if (relationConditionMap[generalAgent.type] && generalAgent.value && generalAgent.value.length) {
      input.gaConditionValue = generalAgent.value.map(i => (generalAgent.options as FilterSelectOption[])[i].id)
      input.gaCondition = relationConditionMap[generalAgent.type]
    }

    if (relationConditionMap[carrier.type] && carrier.value && carrier.value.length) {
      input.carrierConditionValue = carrier.value.map(i => (carrier.options as FilterSelectOption[])[i].id)
      input.carrierCondition = relationConditionMap[carrier.type]
    }

    if (relationConditionMap[source.type] && source.value && source.value.length) {
      input.sourceConditionValue = source.value.map(i => (source.options as FilterSelectOption[])[i].id)
      input.sourceCondition = relationConditionMap[source.type]
    }

    if (relationConditionMap[insuranceProduct.type] && insuranceProduct.value && insuranceProduct.value.length) {
      input.insuranceProductConditionValue = insuranceProduct.value.map(i => (insuranceProduct.options as FilterSelectOption[])[i].id)
      input.insuranceProductCondition = relationConditionMap[insuranceProduct.type]
    }

    if (relationConditionMap[recordType.type] && recordType.value && recordType.value.length) {
      input.recordTypeConditionValue = recordType.value.map(i => (recordType.options as FilterSelectOption[])[i].id)
      input.recordTypeCondition = relationConditionMap[recordType.type]
    }

    if (relationConditionMap[policyType.type] && policyType.value && policyType.value.length) {
      input.policyTypeConditionValue = policyType.value.map(i => (policyTypeKeys as string[])[i])
      input.policyTypeCondition = relationConditionMap[policyType.type]
    }

    if (nonRenew.value !== -1) {
      input.nonRenew = nonRenew.value === 0
    }

    if (payment.value !== -1) {
      input.hasPayment = payment.value === 0
    }

    input.name = sceneName
    input.displayColumns = displayColumns
    input.asc = asc
    input.orderBy = orderBy

    try {
      const result = await this.$apollo.mutate({
        mutation: editPolicyReportRule,
        variables: {
          policyReportRuleId: +this.targetRule.id,
          input
        }
      })

      const res = result.data.editPolicyReportRule
      if (res) {
        showNotification({
          msg: 'Update report rule successfully',
          type: SnackType.Success
        })
      }

      this.handleClose()
      this.handleRefresh()
      this.targetRule = null
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  handleTabChange (index: number) {
    this.tabActive = index
  }

  handleValueChange ({ key, value, type }:{ key: keyof FilterModel, value:any, type?: any }) {
    this.filter[key].value = value
    if (typeof type !== 'undefined') {
      (this.filter[key] as FilterSelect).type = type
    }
  }

  handleConfirm () {
    if (this.isDisplayForm) {
      const valid = (this.$refs.form as Vue & { validate: () => boolean }).validate()

      if (!valid) {
        return
      }
      if (this.targetRule) {
        this.editRulePost()
      } else {
        this.newRulePost()
      }
    } else {
      this.handleClose()
    }
  }

  async deleteRulePost () {
    if (!this.targetRule) {
      return
    }
    try {
      const result = await this.$apollo.mutate({
        mutation: deletePolicyReportRuleById,
        variables: {
          policyReportRuleId: +this.targetRule.id
        }
      })

      const res = result.data.deletePolicyReportRuleById
      if (res) {
        showNotification({
          msg: 'Delete report rule successfully',
          type: SnackType.Success
        })
      }
      this.isDelete = false
      this.targetRule = null
      this.handleRefresh()
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  handleNew () {
    this.displayColumnsMap = Object.assign({}, this.items)
    this.isDisplayForm = true
  }

  handleEdit (rule: PolicyReportRule) {
    const {
      candidatesGeneralAgentOptions, candidatesCarrierOptions, candidatesCarrierProductOptions, candidatesProducerOptions, candidatesRecordTypeOptions,
      policyTypeOptions
    } = this
    const {
      bindDate, effectiveDate, expirationDate, cancelDate,
      gaCondition, gaConditionValue,
      carrierCondition, carrierConditionValue,
      sourceCondition, sourceConditionValue,
      insuranceProductCondition, insuranceProductConditionValue,
      recordTypeCondition,
      recordTypeConditionValue,
      policyTypeCondition,
      policyTypeConditionValue,
      nonRenew, name, displayColumns, asc, orderBy
    } = rule

    this.filter.bindDate.value = bindDate ? bindDate + '' : null
    this.filter.effectiveDate.value = effectiveDate ? effectiveDate + '' : null
    this.filter.expirationDate.value = expirationDate ? expirationDate + '' : null
    this.filter.cancelDate.value = cancelDate ? cancelDate + '' : null
    this.filter.generalAgent.type = gaCondition
      ? gaCondition === RelationCondition.CONTAINS ? 0 : 1
      : -1
    this.filter.carrier.type = carrierCondition
      ? carrierCondition === RelationCondition.CONTAINS ? 0 : 1
      : -1
    this.filter.source.type = sourceCondition
      ? sourceCondition === RelationCondition.CONTAINS ? 0 : 1
      : -1
    this.filter.insuranceProduct.type = insuranceProductCondition
      ? insuranceProductCondition === RelationCondition.CONTAINS ? 0 : 1
      : -1
    this.filter.recordType.type = recordTypeCondition
      ? recordTypeCondition === RelationCondition.CONTAINS ? 0 : 1
      : -1
    this.filter.policyType.type = policyTypeCondition
      ? policyTypeCondition === RelationCondition.CONTAINS ? 0 : 1
      : -1
    this.filter.generalAgent.value = gaConditionValue && gaConditionValue.length
      ? gaConditionValue.map(id => {
        return candidatesGeneralAgentOptions.findIndex(o => +o.id === id)
      })
      : []
    this.filter.carrier.value = carrierConditionValue && carrierConditionValue.length
      ? carrierConditionValue.map(id => {
        return candidatesCarrierOptions.findIndex(o => +o.id === id)
      })
      : []
    this.filter.source.value = sourceConditionValue && sourceConditionValue.length
      ? sourceConditionValue.map(id => {
        return candidatesProducerOptions.findIndex(o => +o.id === id)
      })
      : []
    this.filter.insuranceProduct.value = insuranceProductConditionValue && insuranceProductConditionValue.length
      ? insuranceProductConditionValue.map(id => {
        return candidatesCarrierProductOptions.findIndex(o => +o.id === id)
      })
      : []
    this.filter.recordType.value = recordTypeConditionValue && recordTypeConditionValue.length
      ? recordTypeConditionValue.map(id => {
        return candidatesRecordTypeOptions.findIndex(o => +o.id === id)
      })
      : []

    this.filter.policyType.value = policyTypeConditionValue && policyTypeConditionValue.length
      ? policyTypeConditionValue.map((key: string) => {
        return policyTypeOptions.findIndex(o => o === policyType[key])
      })
      : []

    this.filter.nonRenew.value = nonRenew ? 0 : 1

    this.displayColumns = displayColumns
    this.orderBy = orderBy
    this.asc = asc
    this.sceneName = name

    const colMap: CheckboxModel = displayColumns.reduce((prev: CheckboxModel, curr: string) => {
      prev[curr] = true
      return prev
    }, {})

    for (const key in this.items) {
      this.displayColumnsMap[key] = colMap[key] || false
    }

    this.targetRule = rule

    this.isDisplayForm = true
  }

  handleDelete (rule: PolicyReportRule) {
    this.isDelete = true
    this.targetRule = rule
  }

  clearForm () {
    this.filter = {
      bindDate: {
        label: 'Bind date',
        key: 'bindDate',
        value: null
      },
      effectiveDate: {
        label: 'Effective Date',
        key: 'effectiveDate',
        value: null
      },
      expirationDate: {
        label: 'Expiration Date',
        key: 'expirationDate',
        value: null
      },
      cancelDate: {
        label: 'Cancel Date',
        key: 'cancelDate',
        value: null
      },
      generalAgent: {
        label: 'General Agent',
        key: 'generalAgent',
        type: -1,
        value: [],
        options: []
      },
      carrier: {
        label: 'Carrier',
        key: 'carrier',
        type: -1,
        value: [],
        options: []
      },
      source: {
        label: 'Source',
        key: 'source',
        type: -1,
        value: [],
        options: []
      },
      insuranceProduct: {
        label: 'Insurance Product',
        key: 'insuranceProduct',
        type: -1,
        value: [],
        options: []
      },
      recordType: {
        label: 'Record Type',
        key: 'recordType',
        type: -1,
        value: [],
        options: []
      },
      policyType: {
        label: 'Policy Type',
        key: 'policyType',
        type: -1,
        value: [],
        options: this.policyTypeOptions
      },
      nonRenew: {
        label: 'Non Renew',
        value: -1,
        options: this.yesOrNo
      },
      payment: {
        label: 'Payment',
        value: -1,
        options: this.paymentOptions
      }
    }
    this.sceneName = ''
    this.displayColumns = []
    this.orderBy = null
    this.asc = null
  }

  @Watch('candidatesGeneralAgentOptions')
  handleGeneralAgentOptions () {
    this.filter.generalAgent.options = this.candidatesGeneralAgentOptions.map(item => {
      return {
        id: +item.id,
        value: item.name
      }
    })
  }

  @Watch('candidatesCarrierOptions')
  handleCarrierOptions () {
    this.filter.carrier.options = this.candidatesCarrierOptions.map(item => {
      return {
        id: +item.id,
        value: item.name
      }
    })
  }

  @Watch('candidatesProducerOptions')
  handleSourceOptions () {
    this.filter.source.options = this.candidatesProducerOptions.map(item => {
      return {
        id: +item.id,
        value: item.name
      }
    })
  }

  @Watch('candidatesCarrierProductOptions')
  handleInsuranceProduct () {
    this.filter.insuranceProduct.options = this.candidatesCarrierProductOptions.map(item => {
      return {
        id: +item.id,
        value: item.name
      }
    })
  }

  @Watch('candidatesRecordTypeOptions')
  handleRecordTypeOptions () {
    this.filter.recordType.options = this.candidatesRecordTypeOptions.map(item => {
      return {
        id: +item.id,
        value: item.name
      }
    })
  }

  @Watch('show')
  async onShowChanged (val: boolean) {
    this.showDialog = val
    const { items } = this
    if (val) {
      this.displayColumns = this.$R.keys(items).reduce((prev: string[], curr: string) => {
        if (items[curr]) {
          prev.push(curr)
        }
        return prev
      }, [])
      this.handleGeneralAgentOptions()
      this.handleCarrierOptions()
      this.handleSourceOptions()
      this.handleInsuranceProduct()
      this.handleRecordTypeOptions()
    }
  }

  @Emit('cancel')
  handleCancel () {
    this.isDisplayForm = false
    this.clearForm()
  }

  @Emit('close')
  handleClose () {
    this.isDisplayForm = false
    this.clearForm()
  }

  @Emit('refresh')
  handleRefresh () {}

  onChangeListOrderAsc (val: any) {
    const { list, orderBy, asc } = val

    this.displayColumns = this.$R.keys(list).reduce((prev: string[], curr: string) => {
      if (list[curr]) {
        prev.push(curr)
      }
      return prev
    }, [])

    this.orderBy = orderBy
    this.asc = asc
  }
}
